var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-form',{ref:"form"},[_c('c-form-item',{attrs:{"type":"hidden","name":"organization_id"}}),_c('c-form-item',{attrs:{"type":"input","label":"组织名称","name":"organization_name","required":""}}),_c('c-form-item',{attrs:{"type":"input","label":"审核人手机号码","name":"check_phone","required":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }